import React from 'react';

export default class BaseWidget extends React.Component {
  get statisticsData() {
    throw 'NotImplemented';
  }

  get apiData() {
    return this.props.data.loading || this.props.hasError ? null : this.statisticsData;
  }

  get dataProcessor() {
    throw 'NotImplemented';
  }

  get comment() {
    if (this.props.hasError) {
      return <h3>We’re sorry, something went wrong, please try to reload the page</h3>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/baseWidget.js